import { create } from 'zustand';
import { defaultSYS3020_R01Dto, SYS3020_R01Dto } from 'src/containers/mes/SYS/SYS3020_R01/Dto_SYS3020_R01';
import { ColumnState } from 'ag-grid-community';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';
import { MenuDto } from 'src/dtos/menu/menuDto';

export interface SYS3020_R01Filter {
	userId: string;
	userNm: string;
	systemCd: string;
	menuCd: string;
	useYn: string;
}

// // 사용자 정보 타입
export interface SelectedUserInfo {
	userId: string;
	userNm: string;
}

export interface Store_SYS3020_R01 {

	// 검색 조건 (백엔드로 전송)
	SYS3020_R01Filter: SYS3020_R01Filter;
	SYS3020_R01PastFilter: SYS3020_R01Filter;
	setSYS3020_R01Filter: (filter: Partial<SYS3020_R01Filter>) => void;
	setSYS3020_R01PastFilter: (filter: Partial<SYS3020_R01Filter>) => void;

	// 사용자 목록 (좌측)
	SYS3020_R01List: SysCodeDto[]; // 변수명은 유지하되 주석만 변경
	setSYS3020_R01List: (list: SysCodeDto[]) => void;
	
	// 선택된 사용자
	selectedSYS3020_R01: string | undefined;
	setSelectedSYS3020_R01: (userId: string | undefined) => void;
	initSelectedSYS3020_R01: () => void;

	// 검색 조건에서 선택된 사용자 정보
	selectedUserInfo: SelectedUserInfo | undefined;
	setSelectedUserInfo: (userInfo: SelectedUserInfo | undefined) => void;

	// 메뉴 권한 목록 (우측)
	SYS3020_R01DetailList: SYS3020_R01Dto[];
	setSYS3020_R01DetailList: (list: SYS3020_R01Dto[]) => void;
	setSYS3020_R01DetailListRaw: (list: SYS3020_R01Dto[]) => void;
	insertSYS3020_R01DetailList: (data: SYS3020_R01Dto[], index?: number) => void;
	removeSYS3020_R01Detail: (valueIndex: number) => void;
	updateSYS3020_R01Detail: (valueIndex: number, data: SYS3020_R01Dto) => void;

	// 삭제된 항목 관리
	deletedSYS3020_R01DetailList: string[];
	addDeletedSYS3020_R01DetailList: (idList: string[]) => void;
	removeDeletedSYS3020_R01DetailList: (idList?: string[]) => void;
	
	// 선택된 항목 관리
	selectedSYS3020_R01List: string[];
	setSelectedSYS3020_R01List: (idList: string[]) => void;
	addSelectedSYS3020_R01List: (idList: string[]) => void;
	removeSelectedSYS3020_R01List: (idList?: string[]) => void;
	initSelectedSYS3020_R01List: () => void;
	allSelectedSYS3020_R01List: () => void;

	originalSYS3020_R01DetailList: SYS3020_R01Dto[];
	setOriginalSYS3020_R01DetailList: (list: SYS3020_R01Dto[]) => void;

	// 컬럼 상태 관리
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	allCount: number;
	setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;
	setDetailFetchTrigger: (trigger: boolean) => void;

	// 초기화
	initData: () => void;
}

export const defaultSYS3020_R01Filter : SYS3020_R01Filter = {
	userId: '',
	userNm: '',
	systemCd: '',
	menuCd: '',
	useYn: '',
};

export const useSYS3020_R01Store = create<Store_SYS3020_R01>((set, get) => ({

	// 검색 조건 (백엔드로 전송)
	SYS3020_R01Filter: defaultSYS3020_R01Filter,
	SYS3020_R01PastFilter: defaultSYS3020_R01Filter,
	setSYS3020_R01Filter: (filter) => set((state) => ({ SYS3020_R01Filter: { ...state.SYS3020_R01Filter, ...filter } })),
	setSYS3020_R01PastFilter: (filter) => set((state) => ({ SYS3020_R01PastFilter: { ...state.SYS3020_R01PastFilter, ...filter } })),

	// 권한 그룹 목록
	SYS3020_R01List: [],
	setSYS3020_R01List: (list) => set({ SYS3020_R01List: list }),

	selectedSYS3020_R01: undefined,
	setSelectedSYS3020_R01: (SYS3020_R01: string | undefined) => set((state) => ({
		...state,
		selectedSYS3020_R01: SYS3020_R01,
		selectedSYS3020_R01List: [],
		deletedSYS3020_R01DetailList: [],
		detailFetchTrigger: true,
	})),
	initSelectedSYS3020_R01: () => set({ selectedSYS3020_R01: undefined, SYS3020_R01DetailList: [], detailFetchTrigger: false }),
	
	// 검색 조건에서 선택된 사용자 정보
	selectedUserInfo: undefined,
	setSelectedUserInfo: (userInfo) => set({ selectedUserInfo: userInfo }),

	// 메뉴 권한 목록
	SYS3020_R01DetailList: [],
	setSYS3020_R01DetailList: (list: SYS3020_R01Dto[]) => set((state) => {
		let newList: SYS3020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item) => {
			newList.push({ 
				...defaultSYS3020_R01Dto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			SYS3020_R01DetailList: newList
		}
	}),
	setSYS3020_R01DetailListRaw: (list) => set({ SYS3020_R01DetailList: list }),
	insertSYS3020_R01DetailList: (data, index?) => set((state) => {
		let newList = [...state.SYS3020_R01DetailList];

		const targetRowData = newList.find(item => item.valueIndex === index);
		const targetOrderIndex = targetRowData?.orderIndex || 0;
		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		let maxValueIndex = Math.max(0, ...newList.map(item => item.valueIndex || 0)) + 1;

		const targetRows = newList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if (item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		newList = newList.filter(item => item.orderIndex !== targetOrderIndex);
		newList.push(...targetRows);

		const newData = data.map(item => ({
			...defaultSYS3020_R01Dto,
			...item,
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq,
		}));

		if (index !== undefined) {
			newList.splice(index, 0, ...newData);
		} else {
			newList.push(...newData);
		}

		return {
			...state,
			SYS3020_R01DetailList: newList,
		};
	}),
	removeSYS3020_R01Detail: (valueIndex) => set((state) => {
		const newMenuAuthorityList = [...state.SYS3020_R01DetailList].filter((item) => item.valueIndex !== valueIndex);
		return {
			...state,
			SYS3020_R01DetailList: newMenuAuthorityList
		}
	}),
	updateSYS3020_R01Detail: (valueIndex, data) => set((state) => {
		const _menuAuthorityList = state.SYS3020_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SYS3020_R01DetailList: _menuAuthorityList
		}
	}),

	// 삭제된 항목 관리
	deletedSYS3020_R01DetailList: [],
	addDeletedSYS3020_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedMenuAuthorityList = [...state.deletedSYS3020_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SYS3020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SYS3020_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedMenuAuthorityList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedSYS3020_R01DetailList: _deletedMenuAuthorityList
		}
	}),
	removeDeletedSYS3020_R01DetailList: (idList?: string[]) => set((state) => ({
		deletedSYS3020_R01DetailList: [...state.deletedSYS3020_R01DetailList].filter(value => 
			idList ? !idList.includes(value) : false
		)
	})),

	// 선택된 항목 관리
	selectedSYS3020_R01List: [],
	setSelectedSYS3020_R01List: (idList: string[]) => set({ selectedSYS3020_R01List: idList }),
	addSelectedSYS3020_R01List: (idList: string[]) => set((state) => {
		const _selectedMenuAuthorityList = [...state.selectedSYS3020_R01List];
		if(idList.length > 0) {
			_selectedMenuAuthorityList.push(...idList);
		}
		return {
			...state,
			selectedSYS3020_R01List: _selectedMenuAuthorityList
		}
	}),
	removeSelectedSYS3020_R01List: (idList?: string[]) => set((state) => ({
		selectedSYS3020_R01List: [...state.selectedSYS3020_R01List].filter(value => 
			idList ? !idList.includes(value) : false
		)
	})),
	initSelectedSYS3020_R01List: () => set({ selectedSYS3020_R01List: [] }),
	allSelectedSYS3020_R01List: () => set((state) => ({
		selectedSYS3020_R01List: state.SYS3020_R01DetailList.map(item => item.valueIndex.toString())
	})),

	originalSYS3020_R01DetailList: [],
	setOriginalSYS3020_R01DetailList: (list) => set((state) => {
		let newList: SYS3020_R01Dto[] = [];
		let valueAndOrderIndex = 1;
		list.forEach((item, index) => {
			newList.push({ 
				...defaultSYS3020_R01Dto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSYS3020_R01DetailList: newList
		}
	}),

	// 컬럼 상태
	columnState: null,
	setColumnState: (state) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state) => set({ detailColumnState: state }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),

	allCount: 0,
	setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,
	setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	// 초기화
	initData: () => set({
		SYS3020_R01Filter: defaultSYS3020_R01Filter,
		SYS3020_R01PastFilter: defaultSYS3020_R01Filter,
		SYS3020_R01List: [],
		selectedSYS3020_R01: undefined,
		selectedUserInfo: undefined,
		SYS3020_R01DetailList: [],
		deletedSYS3020_R01DetailList: [],
		selectedSYS3020_R01List: [],
		columnState: null,
		detailColumnState: null,
		allCount: 0,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	}),
}));

export default useSYS3020_R01Store; 